import AxiosConfig from '../config/axios-config'

export default {

  registrarRelatoProblemaSimulado (simuladoId, texto, url, questaoId) {
    return AxiosConfig.secureJalekoAPI().post(`/relato-problema/simulado/${simuladoId}`, { texto: texto, 'url': url, 'questao': questaoId }).then(response => response.data)
  }

}
